import { useEffect, useRef, useState } from 'react';
import { recusar, tamanhoLegivel, tipoDoArquivo } from '@/conversas/midiaEnvio';

/**
 * Prévia do anexo antes de enviar, com legenda opcional.
 *
 * A prévia não é enfeite: o arquivo escolhido some do campo depois do envio, e
 * mandar a foto errada para um paciente não tem desfazer. Miniatura para imagem
 * e vídeo, nome e tamanho para documento — o suficiente para reconhecer o
 * engano antes que ele saia.
 */
export default function AnexarMidia({ arquivo, aoEnviar, aoCancelar, ocupado }) {
  const [legenda, setLegenda] = useState('');
  const [previa, setPrevia] = useState(null);
  const campo = useRef(null);

  const tipo = tipoDoArquivo(arquivo?.type);
  const problema = recusar(arquivo);

  useEffect(() => {
    // Só imagem e vídeo ganham miniatura; documento não tem o que mostrar, e
    // criar o blob à toa deixaria memória presa até o reload.
    if (!arquivo || (tipo !== 'imagem' && tipo !== 'video')) return undefined;
    const url = URL.createObjectURL(arquivo);
    setPrevia(url);
    return () => URL.revokeObjectURL(url);
  }, [arquivo, tipo]);

  useEffect(() => {
    campo.current?.focus();
  }, []);

  if (!arquivo) return null;

  const enviar = (e) => {
    e?.preventDefault?.();
    if (problema || ocupado) return;
    aoEnviar({ arquivo, nome: arquivo.name, tipo, mimetype: arquivo.type, legenda });
  };

  return (
    <div className="anexo">
      <div className="anexo-previa">
        {tipo === 'imagem' && previa && <img src={previa} alt={arquivo.name} />}
        {tipo === 'video' && previa && <video src={previa} controls />}
        {(tipo === 'documento' || tipo === 'audio') && (
          <span className="anexo-icone" aria-hidden="true">
            {tipo === 'audio' ? '🎧' : '📄'}
          </span>
        )}

        <span className="anexo-dados">
          <strong>{arquivo.name}</strong>
          <span className="campo-ajuda">
            {tipo} · {tamanhoLegivel(arquivo.size)}
          </span>
        </span>
      </div>

      {problema ? (
        <p className="erro">{problema}</p>
      ) : (
        <input
          ref={campo}
          type="text"
          value={legenda}
          onChange={(e) => setLegenda(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') enviar(e);
          }}
          placeholder="Legenda (opcional)"
          aria-label="Legenda do anexo"
          disabled={ocupado}
        />
      )}

      <div className="anexo-acoes">
        <button
          type="button"
          className="btn-primario compacto"
          onClick={enviar}
          disabled={Boolean(problema) || ocupado}
        >
          {ocupado ? 'Enviando…' : 'Enviar'}
        </button>
        <button type="button" className="btn-texto" onClick={aoCancelar} disabled={ocupado}>
          Cancelar
        </button>
      </div>
    </div>
  );
}
